import { useNavigate } from 'react-router-dom'

/** Гаджет: Показатель: одно число. */

const KPI_LINKS = {
  utilization: '/admin/analytics',
  cost_per_km: '/admin/analytics',
  line_rate: '/admin/cars?status=in_use',
  active_trips: '/admin/trips?status=active',
  pending_trips: '/admin/trips?status=finished_by_user',
  maintenance_cars: '/admin/cars?status=maintenance',
  urgent_tickets: '/admin/tickets?priority=urgent',
  pending_users: '/admin/users?status=pending',
  overdue_tasks: '/admin/tasks?overdue=1',
}

const ARROW = { up: '↑', down: '↓', flat: '=' }

export function KpiWidget({ data }) {
  const navigate = useNavigate()
  const to = KPI_LINKS[data.metric]
  const d = data.delta

  return (
    <button
      type="button"
      className={`kpi kpi--${data.tone}`}
      onClick={() => to && navigate(to)}
      disabled={!to}
    >
      <span className="kpi__value">
        {data.value}
        {data.unit ? <span className="kpi__unit">{data.unit}</span> : null}
      </span>

      {d && (
        // Цвет по смыслу, а не по знаку: рост срочных тикетов — плохая
        // новость, рост рейсов — хорошая.
        <span
          className={`kpi__delta kpi__delta--${
            d.good === null ? 'flat' : d.good ? 'good' : 'bad'
          }`}
          title={`${d.value > 0 ? '+' : ''}${d.value} ${d.caption}`}
        >
          <span aria-hidden="true">{ARROW[d.direction]}</span>
          {Math.abs(d.value)}
          <span className="kpi__delta-caption">{d.caption}</span>
        </span>
      )}

      <span className="kpi__label">{data.label}</span>
    </button>
  )
}
